import React from "react";
import "./styles.scss";
import Diamond from "./diamond.svg";

export const SmartBuyerCard: React.FC = () => (
  <div className="hero-smartbuyer-betterv2-card">
    <div className="hero-smartbuyer-betterv2-card-top">
      <p className="hero-smartbuyer-betterv2-card-heading">
        All-in-one homebuying
      </p>
      <span className="hero-smartbuyer-betterv2-card-badge">
        <img src={Diamond} alt="" />
        From £2,000
      </span>
    </div>
    <ul className="hero-smartbuyer-betterv2-card-list">
      <li>Mortgage</li>
      <li>Solicitor and legal work</li>
      <li>Home survey report</li>
      <li>Dedicated case manager</li>
      <li>Tracking until completion</li>
    </ul>
  </div>
);
